import React from 'react';
import ReactDOM from 'react-dom';

import styled from 'styled-components';

import { useTranslation } from '../../i18n';
import AutodeskLogo from './AutodeskLogo';

const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.85);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Artifakt Legend';
  color: white;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 58px;
  right: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 24px;
    height: 2px;
    background-color: white;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  &:hover {
    opacity: 0.7;
  }
`;

const Content = styled.div`
  width: 320px;
  gap: 3px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  background: transparent;
  color: white;
  padding: 40px;
  border-radius: 0;
  box-shadow: none;
  max-width: 500px;
  align-items: center;
`;

const LogoContainer = styled.div`
  width: 176px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Message = styled.p`
  font-size: 21px;
  font-weight: 800;
  color: white;
  line-height: 1.4;
`;

const LinkButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 16px;
  font-family: 'Artifakt Legend';
  text-decoration: underline;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.7;
  }
`;

type TrialModalOverlayProps = {
  show: boolean;
  onClose: () => void;
  onRelaunch: () => void;
};

const TrialModalOverlay: React.FC<TrialModalOverlayProps> = ({
  show,
  onClose,
  onRelaunch,
}) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return ReactDOM.createPortal(
    <Overlay data-testid="checkout-overlay">
      <CloseButton
        data-testid="checkout-overlay-close"
        onClick={onClose}
        aria-label="Close"
      />
      <Content>
        <LogoContainer data-testid="checkout-overlay-logo">
          <AutodeskLogo />
        </LogoContainer>
        <Message>{t('CHECKOUT_OVERLAY_MESSAGE')}</Message>
        <LinkButton
          data-testid="checkout-overlay-relaunch"
          onClick={onRelaunch}
        >
          {t('CHECKOUT_OVERLAY_RELAUNCH')}
        </LinkButton>
      </Content>
    </Overlay>,
    document.body
  );
};

export default TrialModalOverlay;
